/* AISTROWISE — mide el banner de cookies de Shopify y publica su altura en --aw-consent-h
   para que las barras fijas inferiores (carrito, WhatsApp) no queden tapadas mientras está visible. */
(function () {
  'use strict';
  var root = document.documentElement;
  var lastH = -1;
  var observed = null;
  function bannerEl() { return document.getElementById('shopify-pc__banner'); }
  function visible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.bottom > 0;
  }
  function measure() {
    var el = bannerEl();
    var h = visible(el) ? Math.round(el.getBoundingClientRect().height) : 0;
    if (h === lastH) return;
    lastH = h;
    if (h > 0) root.style.setProperty('--aw-consent-h', h + 'px');
    else root.style.removeProperty('--aw-consent-h');
  }
  function watchBanner() {
    var el = bannerEl();
    if (el && el !== observed) {
      observed = el;
      try { new MutationObserver(measure).observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] }); } catch (e) {}
      try { if ('ResizeObserver' in window) new ResizeObserver(measure).observe(el); } catch (e) {}
    }
    measure();
  }
  /* El banner lo inserta Shopify más tarde: se vigila solo la inserción de hijos directos en body. */
  function start() {
    watchBanner();
    try { new MutationObserver(watchBanner).observe(document.body, { childList: true }); } catch (e) {}
    document.addEventListener('visitorConsentCollected', function () { setTimeout(measure, 50); setTimeout(measure, 400); });
    window.addEventListener('resize', measure);
    setTimeout(watchBanner, 1500); setTimeout(watchBanner, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
